import React from 'react';
import firebase from 'firebase';
import { connect } from 'react-redux';
import { 
  Card
} from 'semantic-ui-react';

import { signIn } from '../../actions';

import NavBar from '../NavBar';
import SignInForm from './SignInForm';

class SignIn extends React.Component {

  state = { loading: false, error: '' };

  onSubmit = (values) => {
    this.setState({ loading: true });
    this.props.signIn(values);
  }

  componentWillReceiveProps(nextProps) {
    const { loggedIn } = nextProps.auth;
    
    if (!loggedIn) {
      this.setState({ error: nextProps.auth.error });
    }
  }

  renderError = () => {
    if (this.state.error !== '') {
      return <p className='error text-center'>{this.state.error.message}</p>;
    }
  }

  resetPassword = () => {
    var email = window.prompt("Enter your email address to reset your password.","");

    if (email) {
      firebase.auth().sendPasswordResetEmail(email).then(() => {
        alert("Your password has been reset. Please check your email for further instructions.");
      }, (error) => {
        alert("Password reset unsuccesful. Please try again.");
      });
    } else {
      return;
    }
  }

  render() {
    return (
       <div className='welcomeContainer'>   
        <div className='container mainContainer'>
          <NavBar />
          <div className='authForm'>
            <Card centered className='vCard'>
              
              <h1>
                <img alt="" src="https://static1.squarespace.com/static/575ad32a2eeb81b1d93843b6/59220e88db29d658729e2470/59abf0a2e6f2e1f15716e427/1504440486207/zuzu_logo.png"/>
                <br/>
                Zuzu Admin
              </h1>
              {this.renderError()}
              <SignInForm onSubmit={this.onSubmit} />
              <a onClick={this.resetPassword} style={{textAlign: 'center', marginBottom: 20}}>Forgot password?</a>
            </Card>
          </div>
        </div>     
      </div> 
     
    );  
  }
}

const mapStateToProps = state => ({
  form: state.form,
  auth: state.auth
})

export default connect(mapStateToProps, { signIn } )(SignIn);


// WEBPACK FOOTER //
// ./src/components/Auth/SignIn.js